/* HH 2026-10-18 — search drawer, empty state: loads 6 best sellers (sections/hh-predictive-search without a term) only when the
   drawer is actually opened (the element becomes visible), so other pages carry no extra product HTML. Fails quietly. */
(() => {
  if (customElements.get('hh-search-best')) return;
  class HHSearchBest extends HTMLElement {
    connectedCallback() {
      if (this.dataset.done) return;
      const load = () => {
        if (this.dataset.done) return;
        this.dataset.done = '1';
        fetch(this.dataset.url, { credentials: 'same-origin' })
          .then(r => (r.ok ? r.text() : ''))
          .then(text => {
            const el = text && new DOMParser().parseFromString(text, 'text/html').querySelector('.hh-psearch');
            if (el && el.innerHTML.trim()) {
              this.innerHTML = el.innerHTML;
              this.setAttribute('data-filled', '');
              document.dispatchEvent(new CustomEvent('currency:update'));
            }
          })
          .catch(() => {});
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(entries => {
          if (entries.some(e => e.isIntersecting)) { io.disconnect(); load(); }
        });
        io.observe(this);
      } else {
        load();
      }
    }
  }
  customElements.define('hh-search-best', HHSearchBest);
})();
